export default function NetlifyBadge() {
  return (
    <a href="https://www.netlify.com/" rel="noreferrer" target="_blank">
      <img
        src="/netlify.svg"
        loading="lazy"
        alt="Deploys by Netlify"
        height={151}
        width={114}
      />
    </a>
  )
}
